import { META_KEY } from '../components/shortcutHelp/ShortcutHelp'

export const SEARCH_KEYS = [META_KEY, 'K']
export const ADD_ITEM_KEYS = [META_KEY, 'I']
